import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import noticeListApi from "../api/noticeListApi";
import { brandIdMap } from "../../Search/const/brandIdMap";
import {
  findMoreNoticeList,
  findNoticeList,
} from "../../../modules/reducers/notice/getNoticeList";

const useNotice = () => {
  const branchIdARS = useSelector((state) => state.checkArsStatus.branchId);
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const infinity = useSelector((state) => state.getNoticeList.infinity);
  const noticeList = useSelector((state) => state.getNoticeList.noticeList);

  const dispatch = useDispatch();

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [brandCd, setBrandCd] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    setBrandCd(brandIdMap[brandId]?.cd || null);
  }, [brandId]);

  const fetchMoreData = () => {
    const api = noticeListApi();
    const data = {
      store_id: branchId,
      user_id: userId,
      biztp: brandCd,
      offset: offset + limit,
      limit,
    };
    setOffset(offset + limit);
    dispatch(findMoreNoticeList({ ...api, data }));
  };

  useEffect(() => {
    if (selectedBranchId) {
      setBranchId(selectedBranchId);
    } else if (branchIdARS) {
      setBranchId(branchIdARS);
    }
  }, [branchIdARS, selectedBranchId]);

  useEffect(() => {
    const api = noticeListApi();
    if (branchId && userId && brandCd) {
      setOffset(0);
      const data = {
        store_id: branchId,
        user_id: userId,
        biztp: brandCd,
        offset: 0,
        limit,
      };
      dispatch(findNoticeList({ ...api, data }));
    }
  }, [brandCd, branchId, userId]);

  return { noticeList, fetchMoreData, infinity, isMounted };
};

export default useNotice;
